// Watch and react to screen size change using Tornis
const updateValues = ({ size }) => {
	if (size.changed) {
		handleMobileMenu();
		if ( $( ".split-background" ).length ) {
			splitBackground();
		}
	}
};

$(window).on('load', function() {
	// bind the Tornis watch function
	__TORNIS.watchViewport(updateValues);
});